var render = function render(){var _vm=this,_c=_vm._self._c;return _c('app',{attrs:{"background":"#fff"}},[_c('project-edit',{ref:"projectEdit"}),_c('button-list-m',{attrs:{"slot":"foot"},slot:"foot"},[_c('c-button',{on:{"click":_vm.submit}},[_vm._v("确认并提交")])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }